import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import { Box } from '@mui/material';
import { IoClose } from "react-icons/io5";


export default function ImageModel(props) {


    

    console.log("image", props);


    return (
        <React.Fragment>

            <Dialog
                fullWidth
                maxWidth="md"
                open={props.open}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    <Box sx={{ position: 'absolute', top: 5, right: 5, cursor: 'pointer', fontSize: '22px' }} onClick={props.handleClose}>
                        <IoClose />

                    </Box>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {
                            props.fileType === "image" ?
                                <img src={props.image} alt="img" style={{ width: '100%' }} />
                                :
                                <iframe title='PDF' src={props.image} width="800" height="500" />

                        }
                    </DialogContentText>
                </DialogContent>
                <DialogActions>

                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
